<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idprofesion" :options="datos" track-by="id" 
        label="nombre" :searchable="true" :close-on-select="true" :show-labels="false" 
        :multiple="multiple" placeholder="Seleccione la profesion..."></multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,multiple:{type:Boolean,required:false,default:false},
    valueto:{type:String,required:false,default:null },default:{type:Array,required:false,default:null},iddefault:{type:Object,required:false,default:null} },
    data(){
        return{
            datos: [],
            seteado: null,
            modelo: {
                idprofesion: null,
            }
        }
    },
    watch:{
        'modelo.idprofesion': function(){
            if( this.valueto != null ) this.model[this.valueto] = this.modelo.idprofesion;
            else this.model.idprofesion=this.modelo.idprofesion; 
        },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idprofesion = a;
        },
        'iddefault':function(a){
            if( a == null ) return;
            this.modelo.idprofesion = this.datos.find( x => x.id == a.id );
        },
    },
    methods:{
        async getDatos() {
            var vue = this;
            var sql = gql`query{getProfesiones{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getProfesiones;

                if( this.iddefault ){
                    this.modelo.idprofesion = vue.datos.find( x => x.id == this.iddefault.id );
                }
                this.ponerDefecto();
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getProfesiones' ) )
            })
        },

        ponerDefecto(){
            for(let i=0;i<this.datos.length;i++){
                let x = this.datos[i];
                let nombre = x.nombre.toLowerCase();
                
                if(nombre.includes(this.seteado)){
                    window.console.log('-->',nombre, this.seteado);
                    this.modelo.idprofesion = [];
                    this.modelo.idprofesion.push(x);
                }
            }
        },

        // externo
        findPf(exp) {
            this.seteado = exp.toLowerCase();
            this.ponerDefecto();
            // window.console.log('--->', this.datos, exp);
        },

        getModelo(){
            return this.modelo.idprofesion
        }
    },
    mounted(){
        this.getDatos();
    }
}
</script>